import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useDispatch } from "react-redux";

export default function AlertDialog({ infoDialog, setInfoDialog }) {
  const dispatch = useDispatch();
  const handleClose = () => {
    dispatch(setInfoDialog({ open: false }));
  };
  const handleOk = () => {
    if (infoDialog.acaoOk) {
      infoDialog.acaoOk();
      handleClose();
      return;
    }
    handleClose();
  };

  return (
    <Dialog
      open={infoDialog.open}
      onClose={infoDialog.bloquearFechamentoAutomatico ? null : handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description">
      <DialogTitle id="alert-dialog-title">
        {infoDialog.titulo || "Aviso"}
        <IconButton
          aria-label="close"
          onClick={handleOk}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {infoDialog.descricao}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleOk} autoFocus>
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
}
